module.exports = __webpack_public_path__ + "static/media/pen.77c02a74.ico";